// extracted by mini-css-extract-plugin
export default {"wrapper":"_992123c0","description":"_eb4ce275"};